import type { LexicalNode } from "lexical";
import {
  $createRangeSelection,
  $isElementNode,
  $isTextNode,
  $setSelection,
} from "lexical";
import type { TableCellNode } from "@lexical/table";

/** `@lexical/table` 未导出 `$insertTableRowAtNode` 等时，用选区 + AtSelection 等价：整格 element 选区。 */
export function $selectTableCellAsRange(cell: TableCellNode): void {
  const range = $createRangeSelection();
  range.anchor.set(cell.getKey(), 0, "element");
  range.focus.set(cell.getKey(), 0, "element");
  $setSelection(range);
}

/**
 * 行/列重排后恢复选区：折叠到单元格内第一个文本或块起点，保持 `readTableCtx` 可用的 RangeSelection。
 */
export function $placeCaretAtStartOfTableCell(cell: TableCellNode): void {
  const findCaretTarget = (node: LexicalNode): { k: string; o: number; t: "text" | "element" } | null => {
    if ($isTextNode(node)) {
      return { k: node.getKey(), o: 0, t: "text" };
    }
    if ($isElementNode(node)) {
      for (const c of node.getChildren()) {
        const r = findCaretTarget(c);
        if (r) return r;
      }
    }
    return null;
  };
  const hit = findCaretTarget(cell as unknown as LexicalNode);
  const range = $createRangeSelection();
  if (hit) {
    range.anchor.set(hit.k, hit.o, hit.t);
    range.focus.set(hit.k, hit.o, hit.t);
    $setSelection(range);
    return;
  }
  $selectTableCellAsRange(cell);
}
